import React from 'react';
import cx from 'classnames';

import styles from './imgBox.scss';

type ImgBoxProps = {
  imgAvif?: string;
  imgHeight: number;
  imgPng: string;
  imgWebp?: string;
  imgWidth: number;
  name: string;
  reverse?: boolean;
}

const ImgBox = ({
  imgAvif, imgHeight, imgPng, imgWebp, imgWidth, name, reverse = false,
}: ImgBoxProps) => (
  <div className={cx(styles.imgBox, reverse ? styles.left : styles.right)}>
    <picture>
      {imgAvif && <source srcSet={imgAvif} type="image/avif" />}
      {imgWebp && <source srcSet={imgWebp} type="image/webp" />}
      <img
        alt={name}
        className={styles.img}
        height={imgHeight}
        loading="lazy"
        src={imgPng}
        width={imgWidth}
      />
    </picture>
  </div>
);

export default ImgBox;
